import PropTypes from 'prop-types';

const AudioPlayer = (props) => {
	const { source } = props;
	const sources = Array.isArray(source) ? source : [source];

	return (
		<audio controls style={{ width: '100%', minWidth: 280, height: 36 }}>
			{sources.map((src, i) => {
				return <source key={i} src={src} />;
			})}
		</audio>
	);
};

AudioPlayer.propTypes = {
	source: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
	]),
};

export default AudioPlayer;
